export const REPORT_SECTIONS = {
  ABOUT: "ABOUT_THIS_REPORT",
  TOC: "TABLE_OF_CONTENT",
  FIGURES: "LIST_OF_FIGURES",
  SCOPE: "SCOPE_OF_REPORT",
  DEFINITION: "MARKET_DEFINITION",
  METHODOLOGY: "RESEARCH_METHODOLOGY",
  // New Sections
  SEGMENTATION: "MARKET_SEGMENTATION",
  SEGMENTATION_TECH: "SEGMENTATION_TECH",
  SEGMENTATION_APP: "SEGMENTATION_APP",
  SEGMENTATION_REGION: "SEGMENTATION_REGION",
  COMPETITIVE: "COMPETITIVE_LANDSCAPE",
  DEVELOPMENTS: "RECENT_DEVELOPMENTS",
  DYNAMICS: "MARKET_DYNAMICS",
  IP_OVERVIEW: "IP_OVERVIEW",
  FAQ: "FAQ"
};
